module.exports = __webpack_public_path__ + "static/media/44pic.8d182464.jpg";